export class BaseValidator {
    constructor(error) {
        this.error = error;
    }
    getBaseId() {
        return this.error + this.name;
    }
}
